const servicesData = [
  {
    title: 'Enterprise Data & AI Services',
    slug: 'enterprise-data-ai-services',
    description: 'Unlock the full potential of your data with our end-to-end advisory and implementation services across data governance, advanced analytics, AI/ML enablement, and data platform modernization built for performance, privacy, and scale across AWS, Azure, GCP, and OCI.',
    subServices: [
      {
        title: 'Data Governance, Management & Strategy',
      },
      {
        title: 'Data Strategy, Architecture & Compliance',
      },
      {
        title: 'Modern Data Management',
      }
    ]
  },
  {
    title: 'Technology & Cloud Services',
    slug: 'technology-cloud-services',
    description: 'We deliver agile, secure, and cloud-native technology services that align with your enterprise strategy—whether you operate in public cloud, hybrid, multi-cloud, or on-prem ecosystems.',
    subServices: [
      {
        title: 'Managed Cloud & Platform Services',
      },
      {
        title: 'Application Modernization & Cloud Engineering',
      },
      {
        title: 'AI & ML Cloud Engineering & Edge Enablement',
      },
      {
        title: 'BPO & Global Talent Augmentation',
      },
      {
        title: 'Agile Delivery & Testing Services',
      }
    ]
  },
  {
    title: 'Advanced Analytics & AI Enablement',
    slug: 'advanced-analytics-ai-enablement',
    description: 'Turning Raw Data into Predictive, Actionable Intelligence. We help enterprises evolve from descriptive reporting to predictive analytics, AI-powered automation, and real-time decisioning using cloud-native AI/ML stacks across all major clouds.',
    subServices: [
      {
        title: 'Strategy & Use Case Advisory',
      },
      {
        title: 'Data Modeling & Semantics',
      },
      {
        title: 'Business Intelligence & Visualization',
      },
      {
        title: 'Analytics Engineering & AIOps',
      }
    ]
  },
  {
    title: 'Cloud Acceleration Studio',
    slug: 'cloud-acceleration-studio',
    description: 'TQNY ALBYANAT Consulting Cloud Acceleration Studio empowers businesses to adopt agile, intelligent, and scalable cloud ecosystems tailored for AI/ML innovation. We fast-track digital transformation by combining deep cloud expertise with intelligent automation, cloud-native development, and optimized infrastructure ensuring high performance, security, and cost efficiency across multi-cloud and hybrid environments.',
    subServices: [
      {
        title: 'AI-First Cloud Services',
      },
      {
        title: 'Cloud Consultancy & Advisory',
      },
      {
        title: 'Hybrid and Multi-Cloud Strategy',
      },
      {
        title: 'Cloud Migration & Deployment Factory',
      },
      {
        title: 'Application Modernization & Cloud-Native Re-Architecting',
      },
      {
        title: 'Digital Transformation with AI & Cloud',
      },
      {
        title: 'Managed Cloud Services & SRE',
      },
      {
        title: 'On-Prem & Edge AI Cloud Enablement',
      },
      {
        title: 'Cloud FinOps & Governance',
      },
      {
        title: 'AI & Cloud Innovation Labs',
      }
    ]
  },
  {
    title: 'Cybersecurity and Digital Trust',
    slug: 'cybersecurity-and-digital-trust',
    description: 'We integrate Zero Trust Architecture, AI-driven threat detection, and continuous compliance with globally recognized standards like ISO 27001, NIST CSF, MITRE ATT&CK, PDPL, and GDPR—ensuring trust and resilience at every level.',
    subServices: [
      {
        title: 'Threat & Vulnerability Management',
      },
      {
        title: 'Governance, Risk & Compliance (GRC)',
      },
      {
        title: 'Cybersecurity Architecture & Advisory',
      },
      {
        title: '24-7 Managed SOC Services',
      },
      {
        title: 'Cyber Awareness & Capacity Building',
      }
    ]
  }
];

export default servicesData;